import { adjustedFlowActionTypes } from '../constants/actionTypes/ssapActionTypes';
import { changeData } from '../actions/ssap/ssapActionCreators';
import { PAGES } from '../constants/ssap/flows/pagesTypes';

export const customMiddleware = store => next => action => {
    if(action.type === adjustedFlowActionTypes.ADJUST_FLOW && action.isEqual === true) {

        const {
            adjustedFlow,
            data
        } = store.getState().ssap;

        const reopenedForEditing = data.reopenedForEditing;

        if(reopenedForEditing) {
            const eligibleAptcPageIndex = adjustedFlow
                .findIndex(p => p.pageName === PAGES.RECONCILIATION_IN_APTC_PAGE && p.isActive);

            const dataWithAdjustedMaxAchievedPage = {
                ...data,
                maxAchievedPage: eligibleAptcPageIndex !== -1 ? eligibleAptcPageIndex: data.maxAchievedPage,
                reopenedForEditing: false
            };

            store.dispatch(changeData(dataWithAdjustedMaxAchievedPage));
        }
    }

    next(action);
};